<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlECMSchemaVersion}}</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col >
                <otif-ecm-table-info
                    ref="table"
                    :sortCallback="sort_data"
                    :totalRowsCallback="totalRows"
                    :paginated="false"
                    :rows="ecmData"
                    :columns="columns">
                    <template slot="empty">
                        {{ecmResourceStrings.msgNoInfo}}
                    </template>
                </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import ecmCrawlerInfos from '@/ecm/collections/ecmcrawlerinfos.js';

export default {
   
    data() {
        return {
            ecmCrawlerInfos: new ecmCrawlerInfos({paginated: false }),
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            columns: [
            {
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.attributes.name;
                }
            },{
                name: 'version',
                label: 'Version',
                sortable: false,
                editable:false,
                render(row) {
                    return row.attributes.versionNumber;
                }
            }],
             loaded: false
        }
    },

    computed: {
        ecmData() {
            return this.ecmCrawlerInfos.resources;
        }
    },

    methods: {
        refresh(){
            this.loaded = true;
        },
        sort_data(colNumber, dir) {
            const fieldName = this.columns[colNumber].name;
            this.ecmCrawlerInfos.sort(fieldName, dir);
        },
        totalRows() {
            return this.ecmCrawlerInfos.total_count;
        }
    },
    
    mounted() {

        var breadcrumbs = [{
            name: 'info',
            meta: { label: 'Information' }
        },{
            name: 'ecm-config-info',
            meta: { label: 'ECM Schema Version' }
        }];
  
        this.$store.commit('breadcrumbs', breadcrumbs);
    },
   
    created() {
        var that = this;
        that.ecmCrawlerInfos.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                that.loaded = true;
        })
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    },
}

</script>
